import { render, staticRenderFns } from "./Exterior.vue?vue&type=template&id=2227fdb6&scoped=true&"
import script from "./Exterior.vue?vue&type=script&lang=js&"
export * from "./Exterior.vue?vue&type=script&lang=js&"
import style0 from "./Exterior.vue?vue&type=style&index=0&id=2227fdb6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2227fdb6",
  null
  
)

export default component.exports